import React, { useState, useEffect, useCallback } from 'react';
import { useThrottleFn } from 'ahooks';
import { ColorPicker } from '@shakkerai/pro-atoms';

const anyColorToHex = (color) => {
  if (!color) {
    return color;
  }

  if (color.startsWith('#')) {
    return color;
  }

  if (color.startsWith('rgb')) {
    const rgba = color.match(/(\d+)/g);
    const r = parseInt(rgba[0], 10).toString(16);
    const g = parseInt(rgba[1], 10).toString(16);
    const b = parseInt(rgba[2], 10).toString(16);

    return `#${r.padStart(2, '0')}${g.padStart(2, '0')}${b.padStart(2, '0')}`;
  }

  const ctx = document.createElement('canvas').getContext('2d');
  ctx.fillStyle = color;

  return ctx.fillStyle;
};

export const Color = React.memo((props) => {
  const { title, name, value, onChange } = props;
  const [innerValue, setInnerValue] = useState(value);
  const onChangeThrottled = useThrottleFn(onChange, { wait: 300 });

  const handleChange = useCallback(
    (value) => {
      setInnerValue(value);
      onChangeThrottled.run(anyColorToHex(value), name);
    },
    [onChangeThrottled],
  );

  useEffect(() => {
    setInnerValue(value);
  }, [value]);

  return (
    <div className="flex items-center mb-1">
      <span className="flex-1 text-xs text-[#7f7f7f] leading-[14px]">{title}</span>
      <ColorPicker closeOnBlur value={innerValue} onChange={handleChange} />
    </div>
  );
});

export const ColorView = React.memo((props) => {
  const { title, value } = props;
  return (
    <>
      <div className="p-4 flex justify-between items-center">
        <h5 id="model-checkpoints-entry" className="text-[#2d2d2d] text-xs  leading-[14px] font-bold font-gro">
          {title}
        </h5>
        <div className="w-4 h-4 rounded" style={{ backgroundColor: value }} />
      </div>
      <div className="border-t border-[#efefef]" />
    </>
  );
});
